import React from "react";
import { Drawer, Upload, Button, Alert, Typography } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useDrawerCargarHistorico, useCargarHistoricoDescansoMedico } from "../../hooks";

const { Text } = Typography;

const DrawerCargarHistoricoDescansoMedico = () => {
  const { visible, ocultar } = useDrawerCargarHistorico();
  const { setArchivo, fileList, setFileList, cargar, cargando, mensajeExito, mensajeError } =
    useCargarHistoricoDescansoMedico();

  const uploadProps = {
    name: "archivo",
    maxCount: 1,
    fileList,
    accept: ".xlsx,.xls",
    beforeUpload: (file) => {
      setArchivo(file);
      setFileList([file]);
      return false;
    },
    onRemove: () => {
      setArchivo(undefined);
      setFileList([]);
    },
  };

  return (
    <Drawer
      title="Cargar histórico de descanso médico"
      placement="right"
      width={480}
      onClose={ocultar}
      visible={visible}
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary" style={{ display: "block", marginBottom: 12 }}>
          El archivo Excel debe tener las siguientes columnas en la primera fila:
        </Text>
        <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
          <li><Text code>NUMERO_DOCUMENTO_IDENTIDAD</Text> — DNI del colaborador</li>
          <li><Text code>AÑO</Text> — Año del histórico (ej: 2023)</li>
          <li><Text code>DIAS_ACUMULADOS</Text> — Total días DM del año</li>
          <li><Text code>DIAS_SUBSIDIADOS</Text> — Días subsidiados (0 si ninguno)</li>
          <li><Text code>EN_SUBSIDIO_AL_CIERRE</Text> — SI o NO</li>
          <li><Text code>OBSERVACION</Text> — Opcional</li>
        </ul>
        <Text type="secondary" style={{ fontSize: 12 }}>
          El nombre del colaborador se obtendrá automáticamente a partir del DNI.
        </Text>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Upload.Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon" style={{ marginBottom: 8 }}>
            <UploadOutlined />
          </p>
          <p className="ant-upload-text">Clic aquí o suelta tu archivo en esta área</p>
          <p className="ant-upload-hint">Solo se aceptan archivos .xlsx o .xls</p>
        </Upload.Dragger>
      </div>

      <div style={{ marginBottom: 16 }}>
        <Button type="primary" loading={cargando} onClick={cargar} disabled={fileList.length === 0}>
          Cargar Histórico
        </Button>
      </div>

      {mensajeExito && <Alert message={mensajeExito} type="success" showIcon style={{ marginBottom: 8 }} />}
      {mensajeError && <Alert message={mensajeError} type="error" showIcon style={{ marginBottom: 8 }} />}
    </Drawer>
  );
};

export default DrawerCargarHistoricoDescansoMedico;
